import { render } from "./TuitionDiscounts.vue?vue&type=template&id=48331b8f&ts=true"
import script from "./TuitionDiscounts.vue?vue&type=script&lang=ts"
export * from "./TuitionDiscounts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__